import React from 'react';
import PropTypes from 'prop-types';

import PrintProductSizeRoesConfiguratorSample from './PrintProductSizeRoesConfiguratorSample';
import withModal from '../../../../../../../../../../../../../components/global/modal/withModal';

export const PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_SAMPLE_MODAL =
  'modal/PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_SAMPLE';

const propTypes = {
  actionProps: PropTypes.shape({
    printProduct: PropTypes.shape({
      id: PropTypes.string,
    }),
    printSize: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const PrintProductSizeRoesConfiguratorSampleModal = ({
  actionProps: {
    printProduct: actionPropsPrintProduct,
    printSize: actionPropsPrintSize,
  } = {},
  printProduct,
  printSize,
  ...props
}) => {
  return (
    <PrintProductSizeRoesConfiguratorSample
      {...props}
      printProduct={actionPropsPrintProduct ?? printProduct}
      printSize={actionPropsPrintSize ?? printSize}
    />
  );
};

PrintProductSizeRoesConfiguratorSampleModal.propTypes = propTypes;

export default withModal(PrintProductSizeRoesConfiguratorSampleModal, {
  name: PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_SAMPLE_MODAL,
  size: 'sm',
  type: 'full',
});
